import { render, staticRenderFns } from "./TidesCard.vue?vue&type=template&id=a287d496&"
import script from "./TidesCard.vue?vue&type=script&lang=js&"
export * from "./TidesCard.vue?vue&type=script&lang=js&"
import style0 from "./TidesCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports